import React, { Component } from 'react';

class LoadingButton extends Component {
  // enabled, disabled, loading

  buttonEnabled = () => !this.isLoading() && !this.props.disabled;

  isLoading = () => this.props.isLoading === true || this.props.isLoading === 'true';

  buttonContents = () => {
    if (this.isLoading()) {
      return (
        <React.Fragment>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...
        </React.Fragment>
      );
    }

    return this.props.children;
  }

  render() {
    return (
      <button
        type="submit"
        className={this.props.className}
        onClick={this.props.onClick}
        disabled={!this.buttonEnabled()}
      >
        {this.buttonContents()}
      </button>
    );
  }
}

export default LoadingButton;
